import React from 'react'

import { Box, FormComponent } from '@factorialco/deprecated-design-system'

interface Props {
  items: Record<string, React.ReactElement>
}

const Form = ({ items }: Props) => {
  return (
    <Box width="full" paddingRight="s12">
      <FormComponent padding={null}>
        <Box gap="s16">
          {items && Object.values(items).map((item, index) => <Box key={index}>{item}</Box>)}
        </Box>
      </FormComponent>
    </Box>
  )
}

export default Form
